import { isAgentHubEnabled } from 'agentHub/selectors/agentHubSelectors'
import config from 'constants/config'
import { useAppSelector } from 'hooks/reduxHooks'

const MALDIVES_BANNER_END_DATE_MS = new Date('2026-03-07T00:00:00+11:00').getTime()

const MALDIVES_BANNER_BRANDS: Array<App.BrandName> = [
  'luxuryescapes',
  'leagenthub',
  'leagenthub_cvfr',
]

/**
 * Hook to determine if the Maldives Charter banner should be shown.
 * Shows for AU users until campaign end date.
 * Hidden when the LuxPlus gift card campaign is active.
 */
export function useShowMaldivesBanner(): boolean {
  const currentRegionCode = useAppSelector(state => state.geo.currentRegionCode)
  const isBrandSupported = MALDIVES_BANNER_BRANDS.includes(config.BRAND)
  const isRegionSupported = currentRegionCode === 'AU'
  return isBrandSupported && isRegionSupported && Date.now() < MALDIVES_BANNER_END_DATE_MS && !isAgentHubEnabled
}
